import { Modal } from "@/components/ui/Modal.tsx";
import {useState} from "react";
import { Button } from "@/components/ui/Button.tsx";
import {Flex} from "@/components/ui/FlexBox.ts";

interface IAddHeadersModal {
    label: string;
    modalTitle: string;
    disabled?: boolean;
    value?: string;
    children: React.ReactNode;
}

export const FormModal = ({ label, value, modalTitle, disabled, children }: IAddHeadersModal) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <Button
                onClick={() => setIsOpen(true)}
                disabled={disabled}
                style={{ minWidth: 'max-content' }}
                variant="link"
            >
                {value || label}
            </Button>
            <Modal isOpen={isOpen} title={modalTitle} onClose={() => setIsOpen(false)}>
                <Flex>
                    {children}
                </Flex>
            </Modal>
        </div>
    )
}
